
import { store } from '../generic/fetchStore';

export const siteAssessments = store();
